import styled from "styled-components";

export const Container = styled.div`
  padding-bottom: 20px;
  border-bottom: 1px solid #f7f2fa;
`;

// GORDON DESIGN STANDARD 2026-09-15: one row of compact steppers, always —
// flex + nowrap so the row can never collapse into a 2x2 grid the way the
// old CSS-grid-with-media-query layout did (that collapse happened well
// above phone width because the media query keyed off the *viewport*, not
// the narrow settings-pane column the row actually renders in). Steppers
// shrink to fit instead of wrapping.
export const Row = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 6px;
`;

export const StepperSlot = styled.div`
  flex: 1 1 0;
  min-width: 0;
`;
